import { createSlice } from '@reduxjs/toolkit';
import { productPropDelete } from './productPropAsyncThunk';

const productPropDeleteSlice = createSlice({
  name: "productProp",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productPropDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productPropDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productPropDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productPropDeleteSlice.reducer;